import { SharedAngular } from '../../@types/sharedAngular';
import angular, { IScope, ITimeoutService } from 'angular';
import { IFieldControllerField } from './field-controller';
import { Guid } from '@Shared.Angular/@types/guid';
import IProcedureActionDetail from '@Shared.Angular/@types/core/contracts/queryModel/procedure/procedureActionDetail';
import { ProcedureViewMode } from '@Shared.Angular/@types/core/contracts/constants/procedureViewMode';
import OverlayType from '@Shared.Angular/@types/core/contracts/queryModel/procedure/overlayType';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('fg').directive('fgFieldProcedure', [
  function () {
    return {
      replace: true,
      templateUrl: 'angular-form-gen/field-templates/default/procedure.ng.html',
      scope: true,
      controllerAs: 'ctrl',
      controller: [
        '$state',
        '$scope',
        '$timeout',
        'procedureApiService',
        'fileService',
        function (
          $state,
          $scope: IScope,
          $timeout: ITimeoutService,
          procedureApiService: SharedAngular.ProcedureApiService,
          fileService: SharedAngular.FileService
        ) {
          // eslint-disable-next-line @typescript-eslint/no-this-alias
          const ctrl = this;

          ctrl.field = null;
          ctrl.form = null;
          ctrl.loading = true;
          ctrl.loadingProcedureFailed = false;
          ctrl.files = {};

          let hoverTimeout: angular.IPromise<void>;
          const filePromises = {};

          ctrl.init = function (field: IFieldControllerField, form) {
            ctrl.field = field;
            ctrl.form = form;

            $scope.$watch(() => {
              return field.schema.value;
            }, loadNewProcedure);
            if (field.schema.value) {
              loadProcedure(field.schema.value as Guid);
            } else {
              ctrl.loading = false;
            }
          };

          function loadProcedure(id: Guid) {
            const recordProcedureView = [
              STATE_MAPPINGS.publicMap,
              STATE_MAPPINGS.publicForm,
              STATE_MAPPINGS.processmapviewv2,
              STATE_MAPPINGS.flow
            ].some((x) => x === $state.current.name);
            procedureApiService
              .getProcedure(id, ProcedureViewMode.ReadOnly, recordProcedureView)
              .then((procedure) => {
                procedure.actions = procedure.actions
                  .filter((a) => a.active)
                  .sort((a, b) => a.order - b.order);
                procedure.actions.forEach((a) => {
                  a.overlays = a.overlays.filter(
                    (o) => o.type === OverlayType.Highlight
                  );
                });
                ctrl.procedure = procedure;
                ctrl.loadingProcedureFailed = !procedure;
                ctrl.loading = false;
              })
              .catch(() => (ctrl.loadingProcedureFailed = true));
          }

          function loadNewProcedure(newValue?: Guid, oldValue?: Guid) {
            if (newValue && newValue !== oldValue) {
              loadProcedure(newValue);
            }
          }

          ctrl.actionHasContent = function (action: IProcedureActionDetail) {
            return (
              action.modifiedFileId ||
              action.originalFileId ||
              action.description
            );
          };

          ctrl.toggleMinimized = function (
            $event: MouseEvent,
            action: IProcedureActionDetail
          ) {
            if (!ctrl.actionHasContent(action)) {
              return;
            }
            ctrl.loadActionImage(action);
            const element = ($event.currentTarget as HTMLElement).parentElement;
            if (element.classList.contains('minimized')) {
              element.classList.remove('minimized');
            } else {
              element.classList.add('minimized');
            }
          };

          ctrl.loadActionImage = (action: IProcedureActionDetail) => {
            if (!action.originalFileId && !action.modifiedFileId) {
              return;
            }
            if (ctrl.files[action.id] || filePromises[action.id]) {
              return;
            }
            filePromises[action.id] = fileService
              .getFileById(action.modifiedFileId || action.originalFileId)
              .then((result) => {
                if (!result || !result.data) {
                  filePromises[action.id] = null;
                  return;
                }
                return new Promise<string>((resolve, reject) => {
                  const reader = new FileReader();
                  reader.onload = () => resolve(reader.result as string);
                  reader.onerror = reject;
                  reader.readAsDataURL(result.data);
                }).then((dataUrl) => {
                  ctrl.files[action.id] = dataUrl;
                });
              })
              .catch(() => (filePromises[action.id] = null));
          };

          ctrl.setImageView = function (
            action: IProcedureActionDetail | undefined
          ) {
            ctrl.targetAction = action || null;
            ctrl.targetActionIndex = ctrl.procedure.actions.findIndex(
              (action) => action?.id === ctrl.targetAction.id
            );
          };

          ctrl.hideImageView = function () {
            $scope.$applyAsync(() => {
              ctrl.targetAction = null;
              ctrl.targetActionIndex = -1;
            });
          };

          ctrl.getHeaderIndex = function () {
            return ctrl.targetActionIndex + 1;
          };

          ctrl.canNavigateBackwards = function () {
            return ctrl.targetActionIndex > 0;
          };

          ctrl.canNavigateForwards = function () {
            return ctrl.targetActionIndex < ctrl.procedure.actions.length - 1;
          };

          ctrl.navigateBackwards = function () {
            $scope.$apply(() => {
              if (ctrl.targetActionIndex > 0) {
                ctrl.targetActionIndex--;
                ctrl.targetAction =
                  ctrl.procedure.actions[ctrl.targetActionIndex];
              }
            });
          };

          ctrl.navigateForwards = function () {
            $scope.$apply(() => {
              if (ctrl.targetActionIndex < ctrl.procedure.actions.length - 1) {
                ctrl.targetActionIndex++;
                ctrl.targetAction =
                  ctrl.procedure.actions[ctrl.targetActionIndex];
              }
            });
          };
        }
      ]
    };
  }
]);
